import { render, staticRenderFns } from "./recuperarContrasenaModal.vue?vue&type=template&id=67d78dac"
import script from "./recuperarContrasenaModal.vue?vue&type=script&lang=js"
export * from "./recuperarContrasenaModal.vue?vue&type=script&lang=js"
import style0 from "./recuperarContrasenaModal.vue?vue&type=style&index=0&id=67d78dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports